import { baseApi } from './baseApi';

export const rbacApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    getPermissions: builder.query({
      query: () => '/rbac/permissions',
    }),

    listRoles: builder.query({
      query: () => '/rbac/roles',
      providesTags: ['Role'],
      transformResponse: (r) => r.data,
    }),

    getRole: builder.query({
      query: (roleId) => `/rbac/roles/${roleId}`,
      providesTags: (r, e, id) => [{ type: 'Role', id }],
      transformResponse: (r) => r.data,
    }),

    createRole: builder.mutation({
      query: (body) => ({ url: '/rbac/roles', method: 'POST', body }),
      invalidatesTags: ['Role'],
    }),

    updateRole: builder.mutation({
      query: ({ roleId, ...body }) => ({ url: `/rbac/roles/${roleId}`, method: 'PUT', body }),
      invalidatesTags: ['Role', 'UserPermissions', 'MyPermissions'],
    }),

    deleteRole: builder.mutation({
      query: (roleId) => ({ url: `/rbac/roles/${roleId}`, method: 'DELETE' }),
      invalidatesTags: ['Role', 'UserPermissions'],
    }),

    seedRoles: builder.mutation({
      query: () => ({ url: '/rbac/roles/seed', method: 'POST' }),
      invalidatesTags: ['Role'],
    }),

    getUserPermissions: builder.query({
      query: (userId) => `/rbac/users/${userId}/permissions`,
      providesTags: (r, e, userId) => [{ type: 'UserPermissions', id: userId }],
      transformResponse: (r) => r.data,
    }),

    getMyPermissions: builder.query({
      query: () => '/rbac/me/permissions',
      providesTags: ['MyPermissions'],
      transformResponse: (r) => r.data,
    }),

    assignRole: builder.mutation({
      query: ({ userId, roleId }) => ({
        url: `/rbac/users/${userId}/assign`,
        method: 'POST',
        body: { roleId },
      }),
      invalidatesTags: (r, e, { userId }) => [
        'Role',
        { type: 'UserPermissions', id: userId },
        'MyPermissions',
      ],
    }),

    getUserOverrides: builder.query({
      query: (userId) => `/rbac/users/${userId}/overrides`,
      providesTags: (r, e, userId) => [{ type: 'UserPermissions', id: userId }],
    }),
    updateUserOverrides: builder.mutation({
      query: ({ userId, ...body }) => ({
        url: `/rbac/users/${userId}/overrides`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (r, e, { userId }) => [{ type: 'UserPermissions', id: userId }],
    }),
    bulkAssignRole: builder.mutation({
      query: ({ userIds, roleId }) => ({
        url: '/rbac/users/bulk-assign',
        method: 'POST',
        body: { userIds, roleId },
      }),
      invalidatesTags: ['Role', 'UserPermissions', 'MyPermissions'],
    }),
  }),
});

export const {
  useGetPermissionsQuery,
  useListRolesQuery,
  useGetRoleQuery,
  useCreateRoleMutation,
  useUpdateRoleMutation,
  useDeleteRoleMutation,
  useSeedRolesMutation,
  useGetUserPermissionsQuery,
  useGetMyPermissionsQuery,
  useAssignRoleMutation,
  useBulkAssignRoleMutation,
  useGetUserOverridesQuery, useUpdateUserOverridesMutation,
} = rbacApi;
